import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { SharedService } from '../../../../providers/shared.service';
import { StorageService } from '../../../../providers/storage.service';

@Component({
  selector: 'sm-cancel-verification',
  templateUrl: './cancel-verification.component.html',
  styleUrls: ['./cancel-verification.component.scss']
})
export class CancelVerificationComponent implements OnInit, OnDestroy {
  addDiscountForm : FormGroup;
  filteredList: any[] = []
  toCancelDocId:string = ''
formattedAddress: any = ''
entityHash: any = ''
  isMerchantSpecific:Boolean=false;
  isLocationSpecific:Boolean=false;
  isAllMerchant:Boolean=false;
  selectedMerchant:any=[];
  suggestedMerchant:any=[];
  isMerchantSelected:Boolean=false;
  entityList: any[] = [];
  objectoptions = [
    {name: 'angular'},
    {name: 'aise'}
  ]
  
  private apiSubscription: Subscription = new Subscription();
  constructor(private sharedService: SharedService,private storageService : StorageService ,public dialog: MatDialogRef<CancelVerificationComponent>, private _apiservice: ApiService, private router: Router) { 
    this.addDiscountForm = new FormGroup({
     
      'cancellationNotes' : new FormControl(null,[Validators.required]),
      
  });

 
  }



  ngOnInit(): void {
    
    this.toCancelDocId =  this.storageService.getValueFromAppStorage('toCancelDocId')

  // this.apiSubscription = this._apiservice.apiResult.subscribe((data) => {
  //   console.log(data);

  //   // UPDATE_BUSINESS_DOCS_STATUS_RESULT
   
    
   
  // })
  console.log(this.entityList);


    


    
  }

  cancelVerification(){
  console.log(this.addDiscountForm.value.cancellationNotes);




    let data = { 
      hashId: this.toCancelDocId,
      verificationStatus: 0,
      verificationNotes: this.addDiscountForm.value.cancellationNotes 
      }
      console.log(data);

this._apiservice.updateBusinessDocsStatus(data)
this.dialog.close();
setTimeout(() => {
  this.sharedService.sendClickEvent();
}, 2000);

  }


  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }


}
